import React, { useState, useContext } from "react";
import { StoreContext } from "../../../../../order_managment/store";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import MainLayout from "../../../../common/layout/MainLayout";
import "./index.css";
import useForm from "../../../../common/hooks/useForm";
import instance from "../../../../common/api/interceptor";
import { path } from "../../../../constants/apiPath";
import { useNavigate } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import routeConstant from "../../../../routes/utils/routeConstant";
import { LOCAL_STORAGE_KEY, basename, HOST_URL } from "../../../../../config";
import { getUserData } from "../../../../../components/common/utility/Utils";
import axios from "axios";

function ChangePassword() {
  const password = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const confirmpassword = useForm();
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const oldpassword = useForm();
  const [showOldPassword, setShowOldPassword] = useState(false);
  const context = useContext(StoreContext);
  const navigation = useNavigate();

  const onApply = async () => {
    if (!oldpassword.value) {
      oldpassword.setError(true);
      oldpassword.setErrorMsg("Old Password required.");
    } else if (!password.value) {
      password.setError(true);
      password.setErrorMsg("New Password required.");
    } else if (password.value === oldpassword.value) {
      NotificationManager.error("Old and New Passwords are same.", "", 3000);
    } else if (!confirmpassword.value) {
      confirmpassword.setError(true);
      confirmpassword.setErrorMsg("Confirm Password required.");
    } else if (password.value !== confirmpassword.value) {
      NotificationManager.error(
        "New and Confirm Passwords are not same.",
        "",
        3000
      );
    } else {
      context.setBackDropOpen(true);
      const URL = `${HOST_URL}api/v1/AccountData/ChangePassword`;
      let data = {};
      await getUserData(LOCAL_STORAGE_KEY.user_token)
        .then((res) => {
          data = res;
        })
        .catch((err) => {
          console.log(err);
        });
      if (oldpassword.value !== data.password) {
        NotificationManager.error("Old Password is incorrect.", "", 3000);
        context.setBackDropOpen(false);
      } else {
        const params = new URLSearchParams();
        params.append("UserName", data.user_name);
        params.append("OldPassword", oldpassword.value);
        params.append("NewPassword", password.value);
        const header = {
          Authorization: `Bearer ${data.access_token}`,
          UserName: data.user_name,
          UserSecret: oldpassword.value,
          DeviceType: "W",
          MacAddress: "",
          IPAddress: ""
        };
        axios
          .post(URL, params, {
            headers: header
          })
          .then((res) => {
            NotificationManager.success(
              "Password reset successfully",
              "",
              3000
            );
            context.setBackDropOpen(false);
          })
          .catch((err) => {
            context.setBackDropOpen(false);
            if (err.response) {
              NotificationManager.error(err.response.data.Message, "", 3000);
            } else if (err.request) {
            } else if (err.message) {
            } else {
              NotificationManager.error("Something went wrong!", "", 3000);
            }
          });
      }
    }
  };
  return (
    // <MainLayout>
    <div className="_changePasswordComponent">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 col-12 _changePasswordForm">
            <h5>Change Password</h5>
            <div
              className={
                oldpassword.error
                  ? "_inputBox-Parent _error my-3"
                  : "_inputBox-Parent my-3"
              }
            >
              <div className="_inputLabels">
                <label htmlFor="oldpassword">Old Password</label>
              </div>
              <div className="_inputBox _inputPass">
                <input
                  className="form-control"
                  placeholder="New Password"
                  type={showOldPassword ? "text" : "password"}
                  id="oldpassword"
                  onFocus={oldpassword.onFocus}
                  value={oldpassword.value}
                  onChange={oldpassword.onChange}
                />
                <LockIcon />
                {showOldPassword ? (
                  <VisibilityOffIcon
                    className="_showPassword"
                    onClick={() => setShowOldPassword((prev) => !prev)}
                  />
                ) : (
                  <VisibilityIcon
                    className="_showPassword"
                    onClick={() => setShowOldPassword((prev) => !prev)}
                  />
                )}
              </div>
              {oldpassword.error ? <div>{oldpassword.errorMsg}</div> : null}
            </div>
            <div
              className={
                password.error
                  ? "_inputBox-Parent _error my-3"
                  : "_inputBox-Parent my-3"
              }
            >
              <div className="_inputLabels">
                <label htmlFor="newpassword">New Password</label>
              </div>
              <div className="_inputBox _inputPass">
                <input
                  className="form-control"
                  placeholder="New Password"
                  type={showPassword ? "text" : "password"}
                  id="newpassword"
                  onFocus={password.onFocus}
                  value={password.value}
                  onChange={password.onChange}
                />
                <LockIcon />
                {showPassword ? (
                  <VisibilityOffIcon
                    className="_showPassword"
                    onClick={() => setShowPassword((prev) => !prev)}
                  />
                ) : (
                  <VisibilityIcon
                    className="_showPassword"
                    onClick={() => setShowPassword((prev) => !prev)}
                  />
                )}
              </div>
              {password.error ? <div>{password.errorMsg}</div> : null}
            </div>
            <div
              className={
                confirmpassword.error
                  ? "_inputBox-Parent _error my-3"
                  : "_inputBox-Parent my-3"
              }
            >
              <div className="_inputLabels">
                <label htmlFor="confirmpassword">Confirm Password</label>
              </div>
              <div className="_inputBox _inputPass">
                <input
                  className="form-control"
                  placeholder="Confirm Password"
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmpassword"
                  onFocus={confirmpassword.onFocus}
                  value={confirmpassword.value}
                  onChange={confirmpassword.onChange}
                />
                <LockIcon />
                {showConfirmPassword ? (
                  <VisibilityOffIcon
                    className="_showPassword"
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                  />
                ) : (
                  <VisibilityIcon
                    className="_showPassword"
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                  />
                )}
              </div>
              {confirmpassword.error ? (
                <div>{confirmpassword.errorMsg}</div>
              ) : null}
            </div>
            <div className="_changePasswordButton my-3">
              <button onClick={onApply}>APPLY</button>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <img
              src={`/${basename}/Assets/Images/changePasswordImage.png`}
              alt="changePasswordImage"
            />
          </div>
        </div>
      </div>
    </div>
    // </MainLayout>
  );
}

export default ChangePassword;
